const FETCH_MASTER_DATA = "FETCH_MASTER_DATA";

export default FETCH_MASTER_DATA;